<template>
	<div class="box">
		<div class="color_content">
			<div @click="theme('base')">标准</div>
			<div @click="theme('other')">其他</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: "changeTheme",
		methods: {
			theme(type) {
				// 将对应的数据存储到sessionStorage，方便后续使用
				sessionStorage.setItem('type', type)
				// 全局添加样式名称：data-theme，并在sessionStorage获取对应的样式名称的值。
				window.document.documentElement.setAttribute("data-theme", sessionStorage.getItem('type'))
			}
		}
	}
</script>

<style lang="scss" scoped>
	.color_content {
		width: 550px;
		height: 120px;
		margin: 0 auto;
		display: flex;
		align-items: center;
		justify-content: space-between;
		background: #fff;
		border-radius: 2px;
		box-shadow: -2px 5px 12px 4px #f0f0f0;
	}
</style>
